import React, { PropsWithChildren } from "react";

const FiltersIcon = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="22"
      fill="none"
      viewBox="0 0 25 22"
      style={{cursor:"pointer"}}
      {...props}>
      <path
        fill="#fff"
        d="M23.27 2.375h-9.75V1.25c0-.375-.374-.75-.75-.75h-1.5c-.421 0-.75.375-.75.75v1.125H.77c-.421 0-.75.375-.75.75v.75c0 .422.329.75.75.75h9.75V5.75c0 .422.329.75.75.75h1.5c.376 0 .75-.328.75-.75V4.625h9.75c.376 0 .75-.328.75-.75v-.75c0-.375-.374-.75-.75-.75zm0 15H7.52V16.25c0-.375-.374-.75-.75-.75h-1.5c-.421 0-.75.375-.75.75v1.125H.77c-.421 0-.75.375-.75.75v.75c0 .422.329.75.75.75h3.75v1.125c0 .422.329.75.75.75h1.5c.376 0 .75-.328.75-.75v-1.125h15.75c.376 0 .75-.328.75-.75v-.75c0-.375-.374-.75-.75-.75zm0-7.5h-3.75V8.75c0-.375-.374-.75-.75-.75h-1.5c-.421 0-.75.375-.75.75v1.125H.77c-.421 0-.75.375-.75.75v.75c0 .422.329.75.75.75h15.75v1.125c0 .422.329.75.75.75h1.5c.376 0 .75-.328.75-.75v-1.125h3.75c.376 0 .75-.328.75-.75v-.75c0-.375-.374-.75-.75-.75z"></path>
    </svg>
  );
};

export default React.memo(FiltersIcon);
